import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, TrendingUp } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-bold text-gray-900">ProfitPath</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Top Products
            </button>
            <a href="/blog" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Blog
            </a>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              How It Works
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Success Stories
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              FAQ
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <a href="/dashboard">
              <Button variant="outline" className="border-emerald-600 text-emerald-600 hover:bg-emerald-50 px-6">
                📊 Dashboard
              </Button>
            </a>
            <Button onClick={() => scrollToSection('email-capture')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-6">
              Get Free Guide
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-emerald-600 font-medium text-left">
                Top Products
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-emerald-600 font-medium text-left">
                How It Works
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-emerald-600 font-medium text-left">
                Success Stories
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-emerald-600 font-medium text-left">
                FAQ
              </button>
              <a href="/dashboard" className="w-full">
                <Button variant="outline" className="border-emerald-600 text-emerald-600 hover:bg-emerald-50 w-full">
                  📊 Dashboard
                </Button>
              </a>
              <Button onClick={() => scrollToSection('email-capture')} className="bg-emerald-600 hover:bg-emerald-700 text-white w-full">
                Get Free Guide
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
export default Header;
